export enum JilabaKeyEnum {
CommonKey='Com@jilCU2020keY'
}
